import * as Yup from 'yup'

const CmsFeaturedSellerEditFormSchema = Yup.object().shape({
  bio: Yup.string()
    .required('Required'),
  occupation: Yup.string()
    .required('Required')
})

export default CmsFeaturedSellerEditFormSchema
